<template>
    <div :class="isOpen ? 'open' : ''" class="card">
        <div v-if="header" class="card-header bg-transparent" @click="toggle">
            {{ header }}
        </div>
        <div :class="`card-${isTable ? 'table' : 'body'}`" v-show="isOpen">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isOpen: this.defaultState === 'open'
            };
        },
        props: {
            header: String,
            collapse: {
                type: Boolean,
                default: false
            },
            isTable: {
                type: Boolean,
                default: false
            },
            defaultState: {
                default: 'open'
            }
        },
        methods: {
            toggle() {
                if (this.collapse) {
                    this.isOpen = !this.isOpen;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/variables";

    .card {
        margin-bottom: 30px;
        border: 0;
        box-shadow: 0px 0px 0.5px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.24);

        .card-header {
            color: $header-text-color;
            font-size: 14px;
            font-weight: 600;
            border-bottom: none;
        }

        .card-table {
            padding: 1.25rem 0;
        }

        .form-row:last-of-type .form-group,
        .row:last-of-type .form-group {
            margin-bottom: 0;
        }
    }

    .cursor-pointer {
        cursor: pointer;
    }
</style>
